import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');
export const PLATFORM_API_URL = new InjectionToken<string>('PLATFORM_API_URL');
export const DOCUMENT_API_URL = new InjectionToken<string>('DOCUMENT_API_URL');
